/** API route map: URLS.Controller.Position */
export const Position = {
      Name: 'Position/',
      GetAllPaginated: 'get-all-paginated',
      GetPositionClassifications: 'get-position-classifications',
      Add: 'add',
      Update: 'update',
      Delete: 'delete',
};
